/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlanDimensionContributionDto
 */
export interface PlanDimensionContributionDto {
    /**
     * 
     * @type {string}
     * @memberof PlanDimensionContributionDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanDimensionContributionDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanDimensionContributionDto
     */
    planId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanDimensionContributionDto
     */
    dimensionId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanDimensionContributionDto
     */
    dimensionKey?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanDimensionContributionDto
     */
    dimensionDisplayName?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanDimensionContributionDto
     */
    dimensionDomain?: string;
    /**
     * 
     * @type {number}
     * @memberof PlanDimensionContributionDto
     */
    expectedDelta?: number;
    /**
     * 
     * @type {number}
     * @memberof PlanDimensionContributionDto
     */
    realizedDelta?: number;
    /**
     * 
     * @type {Date}
     * @memberof PlanDimensionContributionDto
     */
    realizedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof PlanDimensionContributionDto
     */
    realizedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanDimensionContributionDto
     */
    notes?: string;
    /**
     * 
     * @type {Date}
     * @memberof PlanDimensionContributionDto
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the PlanDimensionContributionDto interface.
 */
export function instanceOfPlanDimensionContributionDto(value: object): value is PlanDimensionContributionDto {
    return true;
}

export function PlanDimensionContributionDtoFromJSON(json: any): PlanDimensionContributionDto {
    return PlanDimensionContributionDtoFromJSONTyped(json, false);
}

export function PlanDimensionContributionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanDimensionContributionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'planId': json['planId'] == null ? undefined : json['planId'],
        'dimensionId': json['dimensionId'] == null ? undefined : json['dimensionId'],
        'dimensionKey': json['dimensionKey'] == null ? undefined : json['dimensionKey'],
        'dimensionDisplayName': json['dimensionDisplayName'] == null ? undefined : json['dimensionDisplayName'],
        'dimensionDomain': json['dimensionDomain'] == null ? undefined : json['dimensionDomain'],
        'expectedDelta': json['expectedDelta'] == null ? undefined : json['expectedDelta'],
        'realizedDelta': json['realizedDelta'] == null ? undefined : json['realizedDelta'],
        'realizedAt': json['realizedAt'] == null ? undefined : (new Date(json['realizedAt'])),
        'realizedBy': json['realizedBy'] == null ? undefined : json['realizedBy'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function PlanDimensionContributionDtoToJSON(json: any): PlanDimensionContributionDto {
    return PlanDimensionContributionDtoToJSONTyped(json, false);
}

export function PlanDimensionContributionDtoToJSONTyped(value?: PlanDimensionContributionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'planId': value['planId'],
        'dimensionId': value['dimensionId'],
        'dimensionKey': value['dimensionKey'],
        'dimensionDisplayName': value['dimensionDisplayName'],
        'dimensionDomain': value['dimensionDomain'],
        'expectedDelta': value['expectedDelta'],
        'realizedDelta': value['realizedDelta'],
        'realizedAt': value['realizedAt'] == null ? undefined : ((value['realizedAt']).toISOString()),
        'realizedBy': value['realizedBy'],
        'notes': value['notes'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

